import { useScopedAppFlagStore } from '@frontend/scope';
import { featureFlags } from '../../../feature-flags';
import { useIsIntegratedOffice } from '../../../hooks';

interface Props {
  roi: 'appointment-reminders' | 'bulk-texting' | 'missedCallText' | 'noShowRate';
}

export const useHasRoiFeature = ({ roi }: Props) => {
  const { isIntegratedOffice } = useIsIntegratedOffice();
  const { getCustomizationFlagValue } = useScopedAppFlagStore();
  const { getFeatureFlagValue } = useScopedAppFlagStore();
  let isFeatureEnabled = false;

  switch (roi) {
    case 'appointment-reminders': {
      isFeatureEnabled = true;
      break;
    }

    case 'bulk-texting': {
      isFeatureEnabled = getFeatureFlagValue(featureFlags.bulkTextRoi);
      break;
    }

    case 'missedCallText': {
      isFeatureEnabled = getCustomizationFlagValue('missedcalltext');
      break;
    }

    case 'noShowRate': {
      isFeatureEnabled = getFeatureFlagValue(featureFlags.noShowRateRoi);
      break;
    }
  }

  return {
    isFeatureEnabled: !!isIntegratedOffice && isFeatureEnabled,
  };
};
